import { handleActions } from "redux-actions";
import { Map } from "immutable";
import cloneDeep from "lodash/cloneDeep";

// Action Type Imports
import { constants as courseConstants } from "../actions/course-actions";

// COURSE's Reducer
export const reducers = {
  [courseConstants.SET_ALL_COURSES]: (state, { payload }) => {
    return state.merge({ allCourses: cloneDeep(payload.courses) });
  },
  [courseConstants.SET_COURSE]: (state, { payload }) => {
    return state.merge({ course: payload.course });
  },
  [courseConstants.SET_COURSE_CLASSES]: (state, { payload }) => {
    return state.merge({ classes: cloneDeep(payload.classes) });
  },
  [courseConstants.SET_COURSE_INSTRUCTORS]: (state, { payload }) => {
    return state.merge({ instructors: cloneDeep(payload.instructors) });
  },
  [courseConstants.SET_COURSE_SPONSORS]: (state, { payload }) => {
    return state.merge({ sponsors: cloneDeep(payload.sponsors) });
  },
  [courseConstants.SET_LOADING]: (state, { payload }) => {
    // return state.merge({ ...payload });
  },
  [courseConstants.SET_COURSES]: (state,  {payload} ) => {
    return state.merge({ allNewCources: payload.courses })
  },
  [courseConstants.SET_COURSE_NEW]: (state, { payload }) => {
    return state.merge({ courseSelected: {...payload.course} })
  },
  [courseConstants.SET_USERS_OF_A_CERTIFICATE]: (state, { payload }) => {
    return state.merge({ users: payload.users })
  },
  [courseConstants.SET_COURSE_ACTIVITY_STATUS_INFO]: (state, { payload }) => {
    return state.merge({ courseActivityStatusInfo: payload.courseActivityStatusInfo })
  },
  [courseConstants.SET_CERTIFICATE_USERS_BY_SLUG]: (state, { payload }) => {
    return state.merge({ certificateUsersInfo: payload.certificateUsersInfo })
  },
};

export const initialState = () =>
  Map({
    loading: false,
    allCourses: [],
    course: {},
    classes: [],
    instructors: [],
    sponsors: [],
    allNewCources: [],
    courseSelected: {},
    users: [],
    courseActivityStatusInfo: {},
    certificateUsersInfo: {}
  });

export default handleActions(reducers, initialState());
